/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { ArrowBackIos, Save } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';
import { Header } from '../../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../../components/layout/main/mainStyles';
import { ButtonIconStyled } from '../../../../views/devices/devicesStyles';
import Strings from '../../../../i18n';
import {
  ItemGridAddScene,
  StyledTitleLabelAddScene
} from './addLightShowStyle';
import { CustomLightShow } from '../../../../components/lightShows/customLightShows';
import { useGetUserScenesByLocationMutation } from '../../../../services/scenes/sceneService';
import { ISelectedCustomScenes } from '../../../../types/Scenes/scenesTypes';
import { useSaveLightShowMutation } from '../../../../services/sequences/sequencesService';
import { AdvanceLightShow } from '../../../../components/lightShows/avancedLightShows';

export const AddLightShowTemplate = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [lightShowName, setLightShowName] = useState<string>('');

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const type = queryParams.get('type');
  const [selectedScenes, setSelectedScenes] = useState<ISelectedCustomScenes[]>(
    []
  );

  const [getUserScenesByLocation, { data: scenes }] =
    useGetUserScenesByLocationMutation();

  const [saveLightShow, { isSuccess }] = useSaveLightShowMutation();

  useEffect(() => {
    if (locationId) {
      getUserScenesByLocation(+locationId);
    }
  }, [locationId, getUserScenesByLocation]);

  const handleSave = () => {
    if (locationId) {
      const payload = {
        locationId: +locationId,
        name: lightShowName,
        scenes: selectedScenes.map((scene) => {
          return {
            ...scene,
            duration: scene.duration * 10,
            transitionDuration: scene.transitionDuration + 10
          };
        })
      };
      const typeValue = type || 'defaultType';
      if (selectedScenes.length > 0 && lightShowName) {
        saveLightShow({ type: typeValue, payload });
      } else {
        toast.error('Required field is missing.');
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.lightShows.lightShowCreatedSuccess);
      navigate(-1);
    }
  }, [isSuccess]);

  return (
    <div>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.scenes.addSceneTitle}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              <ButtonIconStyled size="small" onClick={handleSave}>
                <Save />
              </ButtonIconStyled>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <Grid container>
        <ItemGridAddScene item xs={12}>
          <StyledTitleLabelAddScene>
            {Strings.lightShows.lightShowNameLabel}
          </StyledTitleLabelAddScene>
          <InputText
            className="w-100"
            value={lightShowName}
            onChange={(e) => setLightShowName(e.target.value)}
            placeholder={Strings.lightShows.lightShowNamePlaceholder}
          />
        </ItemGridAddScene>
        {type === 'Custom' && (
          <CustomLightShow
            scenes={scenes || []}
            selectedScenes={selectedScenes}
            setSelectedScenes={setSelectedScenes}
          />
        )}
        {type === 'Advanced' && (
          <AdvanceLightShow
            scenes={scenes || []}
            selectedScenes={selectedScenes}
            setSelectedScenes={setSelectedScenes}
          />
        )}
      </Grid>
    </div>
  );
};
